import { render } from "./PhNewTwitterLogo.vue?vue&type=template&id=3282e7bb"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__